export default __webpack_public_path__ + "static/sound-b085e0fc413883047731c9fc43deb0e5.mp4";